import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { WalletAccountingSyncApiAdapter, type SyncTransactionsListFilters } from '../adapters';
import type { AccountingSyncStatus, SyncTransactionsResponse } from '../models';

/** Tamaño de página fijo para scroll infinito (no se muestra en la UI). */
export const ACCOUNTING_SYNC_PAGE_SIZE = 50;

export interface WalletAccountingSyncInfiniteFilters {
  status?: AccountingSyncStatus;
}

export const useWalletAccountingSyncInfiniteList = (filters: WalletAccountingSyncInfiniteFilters) => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const adapter = useMemo(() => new WalletAccountingSyncApiAdapter(httpClient), [httpClient]);

  const { status } = filters;

  return useInfiniteQuery<SyncTransactionsResponse, Error>({
    queryKey: ['wallet-accounting-sync-transactions-infinite', status ?? 'all'],
    queryFn: ({ pageParam }) =>
      adapter.getList({
        page: pageParam as number,
        per_page: ACCOUNTING_SYNC_PAGE_SIZE,
        ...(status ? { status } : {}),
      } satisfies SyncTransactionsListFilters),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const { current_page, last_page } = lastPage.meta;
      return current_page < last_page ? current_page + 1 : undefined;
    },
    staleTime: 60 * 1000,
  });
};
